import React from 'react'
import { db, auth } from '../../'
import { ref, update } from 'firebase/database'
import { sendPasswordResetEmail } from 'firebase/auth'

const Setting = (props) => {
    const [error, setError] = React.useState('');

    // ユーザー情報の更新
    const updateUserData = async (e) => {
        e.preventDefault();

        if(!e.target[0].value) {
            setError('ユーザー名は必須です');
            return;
        }
        
        update(ref(db, 'users/' + props.userData.uid), {
            username: e.target[0].value,
        }).then(() => {
            alert('ユーザー情報を更新しました');
        }).catch((error) => {
            console.error('ユーザー情報の更新に失敗しました:', error);
            setError('ユーザー情報の更新に失敗しました');
        });
    }

    // アカウント削除
    const deleteAccount = () => {
        if(window.confirm('アカウントを削除しますか？')) {
            auth.currentUser.delete().then(() => {
                alert('アカウントを削除しました');
            }).catch((error) => {
                console.error('アカウントの削除に失敗しました:', error);
                setError('アカウントの削除に失敗しました');
            });
        }
    }
        

  return (
    <div className='p-3 mx-auto max-w-2xl pt-6'>
        <h1 className='text-3xl text-center mb-8'><i className="bi bi-gear me-2"></i>設定</h1>

        <div className='bg-white shadow p-4 rounded-lg mx-4 mb-6'>
            <h2 className='text-2xl mb-3'>設定</h2>

            <form onSubmit={(e) => updateUserData(e)}>
                <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-700'>ユーザ名</label>
                    <input defaultValue={props.userData.username} type='text' className='w-full border border-gray-300 rounded-md p-2 focus:outline-purple-300' />
                </div>
                {/* <div className='mb-3'>
                    <label className='block text-sm font-medium text-gray-700'>メールアドレス</label>
                    <input defaultValue={props.userData.email} type='email' className='w-full border border-gray-300 rounded-md p-2 focus:outline-purple-300' />
                </div> */}

                <button onClick={() => {
                    sendPasswordResetEmail(auth, props.userData.email)
                    .then(() => {
                        alert("パスワード再設定用のメールを送信しました。");
                    })
                    .catch((error) => {
                        console.error('パスワード再設定メールの送信に失敗しました:', error);
                        alert("パスワード再設定用のメールの送信に失敗しました。");
                    });
                }} type="button" className='bg-white hover:bg-gray-100 text-gray-600 p-1 px-4 rounded-md block mt-4 border border-gray-300 tracking-wide'><i className='bi bi-key me-1'></i>パスワード変更</button>

                <button type="submit" className='mx-auto bg-purple-500 hover:bg-purple-600 text-white p-2 px-6 rounded-md block mt-4 shadow-sm tracking-widest'>更新</button>
            </form>
            
            {error && <p className='text-red-600 text-sm mt-2'>{error}</p>}

            <hr className='my-6' />

            {/* アカウント削除 */}
            <button onClick={() => deleteAccount()} className='bg-red-500 hover:bg-red-600 text-white p-2 px-6 rounded-md block mt-4 shadow-sm tracking-widest'>アカウント削除</button>
        </div>
    </div>
  )
}

export default Setting